export const UNAVAILABLE = 'pdp.product_options.unavailable';
export const QUANTITY_INCREASE_ARIA = 'pdp.quantity_increase';
export const QUANTITY_DECREASE_ARIA = 'pdp.quantity_decrease';
export const QUANTITY_ARIA = 'pdp.quantity';
